import React from "react";

// components
import { Redirect, Prompt, NavLink } from "react-router-dom";
import Header from "../../components/Header";
import TextInput from "../../components/Form/components/TextInput";
import SelectInput from "../../components/Form/components/SelectInput";
import NotFound from "../NotFound";
import Pagination from "react-js-pagination";
import moment from "moment/moment";
import DateTextInput from '../../components/Form/components/TextInput/DateTextInput';
import { PulseLoader } from "react-spinners";
import NavigationBar from "../Navigation";

//services
import withAuth from "../../services/withAuth";
import MembersApi from "../../services/portal-api/MembersApi";
import AuthService from "../../services/AuthService";

class IoLogs extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            expandedRows: [],
            totalLogs: 0,
            currentPage: 1,
            logs: [],
            isLoading: false,
            itemsCountPerPage: 50,
            sbApi: '',
            sbToken: '',
            sbTokenValue: '',
            from: '',
            to: '',
        };
    }

    componentDidMount() {
        document.title = "IO Logs - DuskPortal";
        document.body.className = "page--green";
        this.getLogs(this.state.currentPage);
    }

    getLogs = (page, sbApi = '', sbToken = '',  sbTokenValue = '') => {
        this.setState({ isLoading: true });
        MembersApi.getIoLogs((response) => {
            if (response.success) {
                this.setState({
                    logs: response.json.data,
                    totalLogs: response.json.total,
                    isLoading: false,
                });
            }
        }, page, sbApi, sbToken, sbTokenValue);
    };

    toggleRow = (index) => {
        const { expandedRows } = this.state;
        if (expandedRows.includes(index)) {
            this.setState({
                expandedRows: expandedRows.filter((i) => i !== index),
            });
        } else {
            this.setState({
                expandedRows: [...expandedRows, index],
            });
        }
    };

    handlePageChange = (pageNumber) => {
        this.setState({
            currentPage: pageNumber,
        }, () => {
            this.getLogs(this.state.currentPage, this.state.sbApi);
        });
    };

    convertUTCToLocalTime = (dateString) => {
        let date = new Date(dateString);
        const milliseconds = Date.UTC(
            date.getFullYear(),
            date.getMonth(),
            date.getDate(),
            date.getHours(),
            date.getMinutes(),
            date.getSeconds()
        );
        const localTime = new Date(milliseconds);

        let cd =
            localTime.getFullYear() +
            "-" +
            (localTime.getMonth() + 1) +
            "-" +
            localTime.getDate() +
            " " +
            localTime.getHours() +
            ":" +
            localTime.getMinutes() +
            ":" +
            localTime.getSeconds();
            
        return moment(cd).format("YYYY-MM-DD  hh:mm A");
    };

    api = () => {
        return [
            { key: 1, value: 'Member Create' },
            { key: 2, value: 'Member Update' },
            { key: 3, value: 'Reserve Card' },
            { key: 4, value: 'Cancel Card' },
            { key: 5, value: 'Renew Membership' },
        ];
    }

    token = () => {
        return [
            { key: 1, value: 'Status' },
            { key: 2, value: 'Any Keyword' },
            { key: 3, value: 'Date' },
        ];
    }

    status = () => {
        return [
            { key: 1, value: 'Success' },
            { key: 2, value: 'Failed' }
        ];
    }

    handleChange = (event) => {
        const target = event.target;
        const name = target.name;
        const value = target.type === 'checkbox' ? target.checked : target.value;

        this.setState({
            [name]: value,
        }, () => {
            // if (this.state.sbApi !== '') {
            //     this.getLogs(this.state.currentPage, this.state.sbApi, this.state.sbToken, this.state.sbTokenValue);
            // }
        });
    }

    handleDate = (event) => {
        const target = event.target;
        const name = target.name;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const localTime = new Date();
        let tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        let offset = localTime.getTimezoneOffset();
        
        this.setState({
            [name]: event.target.value,
        }, () => {
            if (this.state.sbApi !== '' && this.state.sbToken !== '' && this.state.from !== '' && this.state.to !== '') {
                this.setState({
                    sbTokenValue: this.state.from + '_' + this.state.to + '_' + offset,
                }, () => {
                    console.log('sbTokenValue', this.state.sbTokenValue);
                });
                
            }
        });
    }

    handleReset = () => {
        this.setState({
            currentPage: 1,
            sbApi: '',
            sbToken: '',
            sbTokenValue: '',
            from: '',
            to: '',
        }, () => {
            this.getLogs(this.state.currentPage);
        });
    }

    handleSearch = () => {
        this.setState({
            currentPage: 1,
        }, () => {
            this.getLogs(this.state.currentPage, this.state.sbApi, this.state.sbToken, this.state.sbTokenValue);
        });
    }

    render() {
        const { logs, isLoading, totalLogs, itemsCountPerPage, currentPage } = this.state;

        const paginationStyles = {
            display: "flex",
            flexWrap: "nowrap",
            overflowX: "auto",
            marginTop: "10px",
        };

        const tableStyles = {
            width: "100%",
            borderCollapse: "collapse",
        };

        const thTdStyles = {
            border: "1px solid #ddd",
            padding: "8px",
        };

        const thStyles = {
            ...thTdStyles,
            backgroundColor: "#f2f2f2",
            textAlign: "left",
        };

        const trHoverStyles = {
            ":hover": {
                backgroundColor: "#ddd",
            },
        };

        const evenRowStyles = {
            backgroundColor: "#f9f9f9",
        };

        const containerStyles = {
            width: "100%",
            overflowX: "auto",
        };

        const innerTableStyles = {
            width: "100%",
            tableLayout: "fixed",
        };

        let rows = [];

        logs.forEach((row) => {
            if (row && row.apiName && row.status && row.createdAt) {
                rows.push(
                    <tr
                        key={row.id}
                        
                    >
                        <td style={thTdStyles}>
                            <button
                                onClick={() => this.toggleRow(row.id)}
                            >
                                {this.state.expandedRows.includes(row.id)
                                    ? "-"
                                    : "+"}
                            </button> &nbsp;
                            {row.apiName}
                        </td>
                        <td style={thTdStyles}>{row.status}</td>
                        <td style={thTdStyles}>
                            {row.createdAt != null && this.convertUTCToLocalTime(row.createdAt)}
                        </td>
                    </tr>
                );
                if (this.state.expandedRows.includes(row.id)) {
                    rows.push(
                        <React.Fragment key={`${row.id}`}>
                            <tr>
                                <td colSpan="3">
                                    <div style={containerStyles}>
                                        <table style={innerTableStyles}>
                                            <thead>
                                                <tr>
                                                    <th style={thStyles}>
                                                        Payload
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td
                                                        style={{
                                                            ...thTdStyles,
                                                            whiteSpace:
                                                                "normal",
                                                            wordWrap:
                                                                "break-word",
                                                        }}
                                                    >
                                                        {row.payload}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                            
                                        <table style={innerTableStyles}>
                                            <thead>
                                                <tr>
                                                    <th style={thStyles}>
                                                        Response
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td
                                                        style={{
                                                            ...thTdStyles,
                                                            whiteSpace:
                                                                "normal",
                                                            wordWrap:
                                                                "break-word",
                                                        }}
                                                    >
                                                        {row.response}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </td>
                            </tr>
                        </React.Fragment>
                    );
                }
            }
        });
        
        return AuthService.can("IO logs") ? (
            <div>
                <Header />
                <main className="content padding--80--bot" role="main">
                    <div className="container container--wide padding--40">
                        {AuthService.getAdminType() == 1 && (
                            <div className="info-wrap col gutter--40 margin--10--bot" style={{ borderBottom: "1px solid #ccc", display: "flex", flexWrap: "wrap" }}>
                                <div className="col">
                                    <NavigationBar />
                                </div>
                            </div>
                        )}

                        <h2 className="text--light text--color text--40">
                            IO Logs
                        </h2>

                        <div className="table--overflow clearfix margin--30--top" style={{ overflow: "auto" }}>
                            <div className="col">
                                <div className="col-2 gutter--40 ">
                                    
                                    <div className="col">
                                        <div className="col-2 gutter--40 ">
                                            <div className="col">
                                                <SelectInput
                                                    name="sbApi"
                                                    label="Select API"
                                                    options={this.api()}
                                                    value={this.state.sbApi}
                                                    onChange={this.handleChange}
                                                />
                                            </div>
                                            <div className="col">
                                                <SelectInput
                                                    name="sbToken"
                                                    label="Search By"
                                                    options={this.token()}
                                                    value={this.state.sbToken}
                                                    onChange={this.handleChange}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                        
                                    <div className="col">
                                        <div className="col-2 gutter--40 "> 
                                            <div className="col">
                                                {this.state.sbToken == 1 &&
                                                    <SelectInput
                                                        name="sbTokenValue"
                                                        label="Select status"
                                                        options={this.status()}
                                                        value={this.state.sbTokenValue}
                                                        onChange={this.handleChange}
                                                    />
                                                }

                                                {this.state.sbToken == 2 &&
                                                    <TextInput
                                                        name="sbTokenValue"
                                                        label="Search By Keyword"
                                                        value={this.state.sbTokenValue}
                                                        onChange={this.handleChange}
                                                    />
                                                }

                                                {this.state.sbToken == 3 &&
                                                    <DateTextInput
                                                        name="from"
                                                        label="From"
                                                        type="datetime-local"
                                                        placeholder="DD/MM/YYYY"
                                                        value={this.state.from}
                                                        onChange={this.handleDate}
                                                    />
                                                }
                                            </div>
                                            <div className="col">
                                                {this.state.sbToken == 3 &&
                                                    <DateTextInput
                                                        name="to"
                                                        label="To"
                                                        type="datetime-local"
                                                        placeholder="DD/MM/YYYY"
                                                        value={this.state.to}
                                                        onChange={this.handleDate}
                                                    />
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="col-2 gutter--40">
                                            <div className="col">
                                                <button className="btn btn--xsmall btn--color" onClick={this.handleSearch}>Search</button>&nbsp;
                                                <button className="btn btn--xsmall btn--color" onClick={this.handleReset}>Reset</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <br />
                        </div>

                        <h5 className="text--light text--color">
                            Current Page: {currentPage}
                        </h5>
                        
                        <div style={containerStyles}>
                            <table style={tableStyles}>
                                <thead>
                                    <tr>
                                        <th style={thStyles}>Service</th>
                                        <th style={thStyles}>Status</th>
                                        <th style={thStyles}>Created At</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {isLoading ? 
                                        <PulseLoader color="#000" size={5} />
                                    : 
                                        rows 
                                    }
                                </tbody>
                            </table>
                        </div>
                        {totalLogs > 50 && (
                            <div style={paginationStyles}>
                                <nav>
                                    <Pagination
                                        activePage={currentPage}
                                        itemsCountPerPage={itemsCountPerPage}
                                        totalItemsCount={totalLogs}
                                        pageRangeDisplayed={5}
                                        onChange={this.handlePageChange}
                                        innerClass="pagination"
                                    />
                                </nav>
                            </div>
                        )}
                    </div>
                </main>
                {/* <LoadingSpinner isVisible={isLoading} /> */}
            </div>
        ) : (
            <NotFound forbidden={true} />
        );
    }
}

export default withAuth(IoLogs);
